// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const GoalsPage = lazy(() => import('./pages/GoalsPage'));
const FeedbackPage = lazy(() => import('./pages/FeedbackPage'));
const ReviewsPage = lazy(() => import('./pages/ReviewsPage'));
const LearningPage = lazy(() => import('./pages/LearningPage'));
const SkillsPage = lazy(() => import('./pages/SkillsPage'));
const SuccessionPage = lazy(() => import('./pages/SuccessionPage'));
const CareerPathsPage = lazy(() => import('./pages/CareerPathsPage'));

export const PerformanceRoutes: RouteObject = {
  path: 'performance',
  element: <ModuleGuard moduleId="people.performance" />,
  handle: { crumb: 'Performance & Learning' },
  children: [
    { index: true, element: <Navigate to="goals" replace /> },
    { path: 'goals', element: <GoalsPage />, handle: { crumb: 'Goals' } },
    { path: 'feedback', element: <FeedbackPage />, handle: { crumb: 'Feedback' } },
    { path: 'reviews', element: <ReviewsPage />, handle: { crumb: 'Reviews' } },
    { path: 'learning', element: <LearningPage />, handle: { crumb: 'Learning' } },
    { path: 'skills', element: <SkillsPage />, handle: { crumb: 'Skills' } },
    { path: 'succession', element: <SuccessionPage />, handle: { crumb: 'Succession' } },
    { path: 'career-paths', element: <CareerPathsPage />, handle: { crumb: 'Career Paths' } },
  ],
};
